import React, {
  FunctionComponent,
  ReactElement,
  useEffect,
  useState
} from 'react';

const LOCAL_STORAGE_KEY = 'eventPopups';

interface IEventPopupsVisibilityData {
  [key: string]: boolean; // true means hidden
}
const DEFAULT_DATA: IEventPopupsVisibilityData = {};

function getInitialData(): IEventPopupsVisibilityData {
  const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);

  if (storedData) {
    return JSON.parse(storedData);
  }

  return DEFAULT_DATA;
}

export function withEventPopup(
  Component: FunctionComponent
): FunctionComponent {
  function EventPopupWrapper(props): ReactElement {
    useEffect(() => {
      getInitialData();
    }, []);

    return <Component {...props} />;
  }

  return EventPopupWrapper;
}
